// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___s3blA","root__item":"style-module__root__item___ujgM3","root__item_btn":"style-module__root__item_btn___ad5PB","root__menu":"style-module__root__menu___cMb1M","root__menu_item":"style-module__root__menu_item___UoeyI"};
    if(module.hot) {
      // 1697460464264
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  